import { render, staticRenderFns } from "./ReportPromoSuperAdminLegacy.vue?vue&type=template&id=98f021ee"
import script from "./ReportPromoSuperAdminLegacy.vue?vue&type=script&lang=js"
export * from "./ReportPromoSuperAdminLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports